export const MATRIX_TEMPLATE_TYPES = {
  TECHNICAL_ASSESSMENT: 'TechnicalAssessment',
  MANAGER_REVIEW: 'ManagerReview',
  PEER_REVIEW: 'PeerReview',
  CLIENT_FEEDBACK: 'ClientFeedback',
  SELF_ASSESSMENT: 'SelfAssessment',
  HIRING_EVALUATION: 'HiringEvaluation'
};

/**
 * Converts a camelCase template type name to its corresponding MATRIX_TEMPLATE_TYPES constant
 * @param {string} camelCaseType - The template type in camelCase (e.g., "TechnicalAssessment")
 * @returns {string} The matching template type constant value
 */
export const getTemplateTypeConstant = (camelCaseType) => {
  // Convert camelCase to CONSTANT_CASE (e.g., TechnicalAssessment -> TECHNICAL_ASSESSMENT)
  const constantCase = camelCaseType.replace(/([A-Z])/g, '_$1').toUpperCase().slice(1);
  return MATRIX_TEMPLATE_TYPES[constantCase];
};

export const getTemplateTypeColor = (type) => {
  switch (type) {
    case MATRIX_TEMPLATE_TYPES.TECHNICAL_ASSESSMENT:
      return '#2E90FA'; // Blue for technical assessment
    case MATRIX_TEMPLATE_TYPES.MANAGER_REVIEW:
      return '#16A34A'; // Green for manager review
    case MATRIX_TEMPLATE_TYPES.PEER_REVIEW:
      return '#6366F1'; // Indigo for peer review
    case MATRIX_TEMPLATE_TYPES.CLIENT_FEEDBACK:
      return '#F59E0B'; // Amber for client feedback
    case MATRIX_TEMPLATE_TYPES.SELF_ASSESSMENT:
      return '#8B5CF6'; // Purple for self assessment
    case MATRIX_TEMPLATE_TYPES.HIRING_EVALUATION:
      return '#EC4899'; // Pink for hiring evaluation
    default:
      return '#475569'; // Default slate color
  }
};

export const getTemplateTypeText = (type) => {
  switch (type) {
    case MATRIX_TEMPLATE_TYPES.TECHNICAL_ASSESSMENT:
      return 'Technical Assessment';
    case MATRIX_TEMPLATE_TYPES.MANAGER_REVIEW:
      return 'Manager Review';
    case MATRIX_TEMPLATE_TYPES.PEER_REVIEW:
      return 'Peer Review';
    case MATRIX_TEMPLATE_TYPES.CLIENT_FEEDBACK:
      return 'Client Feedback';
    case MATRIX_TEMPLATE_TYPES.SELF_ASSESSMENT:
      return 'Self Assessment';
    case MATRIX_TEMPLATE_TYPES.HIRING_EVALUATION:
      return 'Hiring Evaluation';
    default:
      return 'Unknown Type';
  }
};

export const getTemplateTypeBorderColor = (type) => {
  switch (type) {
    case MATRIX_TEMPLATE_TYPES.TECHNICAL_ASSESSMENT:
      return '#2E90FA'; // Blue border
    case MATRIX_TEMPLATE_TYPES.MANAGER_REVIEW:
      return '#16A34A'; // Green border
    case MATRIX_TEMPLATE_TYPES.PEER_REVIEW:
      return '#6366F1'; // Indigo border
    case MATRIX_TEMPLATE_TYPES.CLIENT_FEEDBACK:
      return '#F59E0B'; // Amber border
    case MATRIX_TEMPLATE_TYPES.SELF_ASSESSMENT:
      return '#8B5CF6'; // Purple border
    case MATRIX_TEMPLATE_TYPES.HIRING_EVALUATION:
      return '#EC4899'; // Pink border
    default:
      return '#475569'; // Default slate border
  }
};

export const getTemplateTypeTextColor = (type) => {
  switch (type) {
    case MATRIX_TEMPLATE_TYPES.TECHNICAL_ASSESSMENT:
      return '#1D4ED8'; // Darker blue for text
    case MATRIX_TEMPLATE_TYPES.MANAGER_REVIEW:
      return '#15803D'; // Darker green for text
    case MATRIX_TEMPLATE_TYPES.PEER_REVIEW:
      return '#4338CA'; // Darker indigo for text
    case MATRIX_TEMPLATE_TYPES.CLIENT_FEEDBACK:
      return '#B45309'; // Darker amber for text
    case MATRIX_TEMPLATE_TYPES.SELF_ASSESSMENT:
      return '#6D28D9'; // Darker purple for text
    case MATRIX_TEMPLATE_TYPES.HIRING_EVALUATION:
      return '#BE185D'; // Darker pink for text
    default:
      return '#1E293B'; // Darker slate for text
  }
}; 